import { roundApplicationPath } from "@lib/roundSlugs";
import { Button } from "@sfc/ui";
import { ArrowRight } from "lucide-react";
import { Link } from "wouter";

export function OpenFundingOpportunities({
  applications,
}: {
  applications: {
    roundId: string;
    roundName: string;
    roundSlug?: string | null;
  }[];
}) {
  if (applications.length === 0) {
    return null;
  }

  return (
    <section
      aria-label="Open funding opportunities"
      className="open-funding-opportunities divide-y divide-primary/10 rounded-lg border border-primary/20 border-l-[3px] border-l-primary bg-primary/5"
    >
      {applications.length < 3 ? (
        applications.map((application) => (
          <div
            key={application.roundId}
            className="flex flex-wrap items-center justify-between gap-4 p-6"
          >
            <div className="min-w-0 flex-[1_1_10rem] space-y-2">
              <p className="body-sm text-primary">Open for applications</p>
              <h2 className="heading-md [overflow-wrap:anywhere]">
                {application.roundName}
              </h2>
            </div>
            <Button
              nativeButton={false}
              size="lg"
              className="h-auto min-h-11 max-w-full shrink-0 whitespace-normal py-2"
              render={<Link href={roundApplicationPath(application)} />}
            >
              Preview application <ArrowRight data-icon="inline-end" />
            </Button>
          </div>
        ))
      ) : (
        <div className="flex flex-wrap items-center justify-between gap-4 p-6">
          <div className="min-w-0 flex-[1_1_10rem] space-y-2">
            <h2 className="heading-md">Find Funding for Your Team</h2>
            <p className="body-sm text-primary">
              {applications.length} funding rounds are open
            </p>
          </div>
          <Button
            nativeButton={false}
            size="lg"
            className="h-auto min-h-11 max-w-full shrink-0 whitespace-normal py-2"
            render={<Link href="/apply" />}
          >
            Explore funding rounds <ArrowRight data-icon="inline-end" />
          </Button>
        </div>
      )}
    </section>
  );
}
